import { render, staticRenderFns } from "./FavoriteGroupItems.vue?vue&type=template&id=5efedbda&scoped=true"
import script from "./FavoriteGroupItems.ts?vue&type=script&lang=ts&external"
export * from "./FavoriteGroupItems.ts?vue&type=script&lang=ts&external"
import style0 from "./FavoriteGroupItems.scss?vue&type=style&index=0&id=5efedbda&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efedbda",
  null
  
)

export default component.exports